import { Product } from 'src/shared/types/product';
import { RFQ } from 'src/shared/types/rfq';
import parseDate from 'src/shared/utils/parseDate';

/**
 * Products have no `updated_at` of their own, so the last relevant update is
 * the closest thing to "last activity"; brand new products fall back to their
 * creation date.
 */
export const getProductLastUpdatedAt = (product: Product): Date | null =>
  parseDate(product.last_relevant_update?.created_at) ??
  parseDate(product.detail.created_at);

/** Last time the user touched an unfinished (unpublished) product. */
export const getIncompleteProductLastUpdatedAt = (product: RFQ): Date | null =>
  parseDate(product.updated_at) ?? parseDate(product.created_at);

/**
 * Most recently updated first. Entries without a usable date sink to the
 * bottom instead of scrambling the order the way a `NaN` comparison would.
 */
export const sortByLastUpdated = <T>(
  items: T[],
  getLastUpdatedAt: (item: T) => Date | null
): T[] =>
  [...items].sort(
    (a, b) =>
      (getLastUpdatedAt(b)?.getTime() ?? 0) -
      (getLastUpdatedAt(a)?.getTime() ?? 0)
  );
